import React, { Component } from "react";
import Button from "react-bootstrap-button-loader";
import Dropzone from "react-dropzone";
import LocaleStrings from "Languages";

export default class VideoUploader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filepath: props.filepath,
    };
    this.resetImage = this.resetImage.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps) {
      if (nextProps.filepath !== "" && this.state.filepath === "") {
        this.setState({ filepath: nextProps.filepath });
      }
    }
  }

  onDropFile = (files) => {
    var that = this;
    let file = files[0];

    let reader = new FileReader();
    reader.onloadend = () => {
      var item = reader.result;

      let removeSpace = file.name.replace(/ /g, "_");
      let split = removeSpace.split(".");

      let ext = split.pop();
      let newFname = split.join();

      // Replacing special char with _
      // var  newFname = 'a@A9 8_)*AÀń.'
      let newFnm = newFname.replace(/[^\w\s]/gi, "_");

      let fileName = newFnm + "." + ext;

      var data = { file: item, filename: fileName };
      that.props.onFileSave(data);
      that.props.onFileChnageLocally(true);
    };
    reader.readAsDataURL(file);
  };

  resetImage = () => {
    this.setState({ filepath: "" });
    this.props.onFileSave("");
    this.props.onFileChnageLocally(true);
  };

  render() {
    let {
      className,
      displaySize,
      insideImage,
      insideImageStyle,
      insideText,
      fileName,
      fileOld,
    } = this.props;
    let fileUrl = this.state.filepath;

    var hideDropZoneClass = "";
    var hideControlButton = "hide-feature";

    if (fileUrl && fileUrl !== "file object not found") {
      hideDropZoneClass = "hide-feature";
      hideControlButton = "";
    }

    var aStyle = {
      padding: "5px",
      width: this.props.width,
      height: this.props.height,
      border: "1px solid #2676ea",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      borderRadius: 5,
    };

    var imageDisplayContaner = {
      width: displaySize.width,
      height: displaySize.height,
    };

    return (
      <div style={imageDisplayContaner}>
        <Dropzone onDrop={this.onDropFile} accept="video/*" multiple={false}>
          <div className={`${className} ${hideDropZoneClass}`}>
            <img src={insideImage} style={insideImageStyle} />
            <div className="drag-drop-text">{insideText}</div>
          </div>
        </Dropzone>

        {fileUrl && fileUrl != "" ? (
          <video
            className="b-radius-5"
            width={displaySize.width}
            height={displaySize.height}
            controls
          >
            <source src={fileUrl} type="video/mp4" />
            {/* <source src="movie.ogg" type="video/ogg"> */}
            Your browser does not support the video tag.
          </video>
        ) : (
          ""
        )}

        <div className={`video-remove-button-position ${hideControlButton}`}>
          <Button
            type="button"
            className={`btn-custom-default-sm`}
            onClick={this.resetImage}
          >
            {" "}
            {LocaleStrings.button_remove}{" "}
          </Button>
        </div>
      </div>
    );
  }
}
